import { useDroppable } from '@dnd-kit/core';

export default function Droppable({ children, id, ...props }) {
   const { isOver, setNodeRef } = useDroppable({
      id: id,
   });

   const style = {
      background: isOver ? 'rgba(0,0,0,0.1)' : undefined,
      borderRadius: 8,
      padding: isOver ? 4 : undefined,
      transition: 'all 0.2s ease',
   };

   return (
      <div ref={setNodeRef} style={style} {...props}>
         {children}
      </div>
   );
}
